import $ from "jquery";
import videojs from "video.js";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import GameLogic from "@bd-core/game-logic";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import {
    getRoomAnswers,
    maybeUpdateRoomStatus,
    removeRoomAnswer,
    saveFinalRoomAnswers,
    setRoomTotalScores,
    setTeamLogos,
    setTotalAttempt,
    updateCurrentScreen,
    updateRoomAnswer,
} from "@bd-core/firebase-actions";
import {
    getCurrentRoomScreen,
    getFinalTeamAnswers,
    getIsRoomTimeOut,
    getRoomLogo,
    getRoomScore,
    getRoomStatus,
    getTeamAnswers,
    getTotalAttempt,
} from "@bd-stores/game-progress";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { isLeader } from "@bd-stores/game-progress";
import { isTestMode } from "@bd-utils/test-mode";

export class RoomHotspotPuzzle extends BD_Component {
    constructor() {
        super();

        this.id = "hotspot_puzzle";
        this.templateID = "hotspot_puzzle-template";

        this.elms = {
            // narrative popup
            narrativePopup: ".js-narrative-popup",
            narrativeCloseBtn: ".js-close-narrative-popup",

            // reward screen
            rewardScreen: ".js-reward-feedback",
            rewardTitle: ".js-reward-title",
            rewardSubtitle: ".js-reward-subtitle",
            rewardDescription: ".js-reward-description",
            rewardScore: ".js-reward-score",
            rewardContinueBtn: ".js-reward-continue-btn",
            triggerRewardScreenBtn: ".btn-continue-reward-screen",

            // customization
            customizationScreen: ".js-customization",
            customRewardWrapper: ".challange-prize__item-wrapper",
            customizationContinueBtn: ".js-customization-continue-btn",
            customizationCategory: ".js-category",
            logoImage: ".js-logo",

            // puzzle
            popupItem: ".js-popup-item",
            popupHotspot: ".js-popup-hotspot",
            popupItemTitle: ".js-popup-item-title",
            selectionBoxWrapper: ".js-selection-wrapper",
            selectionBox: ".js-selection-box",
            flowchartBox: ".js-flowchart-box",
            selectedItemTitle: ".js-selected-item-title",
            selectedItemImage: ".js-selected-item-image",
            removeSelected: ".js-remove-btn",
            checkBtn: ".js-submit",
            continueBtn: ".js-continue",
            hotspotBtn: ".js-trigger-popup",
            toggleDashboard: ".js-toggle-dashboard",

            skipVideoBtn: ".js-skip-video"
        };

        this._events = this.getEvents();

        this._data = {};
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.hotspotBtn,
                handler: this.togglePopupItem,
            },
            {
                event: "change",
                selector: elms.selectionBox,
                handler: this.onSelectBox,
            },
            {
                event: "click",
                selector: elms.removeSelected,
                handler: this.onRemoveBox,
            },
            {
                event: "mouseenter",
                selector: elms.flowchartBox,
                handler: this.handleRemoveButtonVisibility,
            },
            {
                event: "click",
                selector: elms.checkBtn,
                handler: this.checkAnswer,
            },
            {
                event: "click",
                selector: elms.continueBtn,
                handler: this.goToRewardScreen,
            },
            {
                event: "click",
                selector: elms.triggerRewardScreenBtn,
                handler: this.goToRewardScreen,
            },
            {
                event: "click",
                selector: elms.rewardContinueBtn,
                handler: this.goToCustomizationScreen,
            },
            {
                event: "click",
                selector: elms.customizationContinueBtn,
                handler: this.setSelectedLogo,
            },
            {
                event: "click",
                selector: elms.narrativeCloseBtn,
                handler: this.closeNarrativePopup,
            },
            {
                event: "click",
                selector: elms.toggleDashboard,
                handler: this.toggleHideDashboard,
            },
            {
                event: "click",
                selector: elms.skipVideoBtn,
                handler: this.skipIntroVideo
            }
        ];
    }

    beforeInit() {
        this.render();
        this.setupSlider();
        this.setGameState();
        this.setTestMode();
    }

    getModifiedData() {
        const roomData = this._data;

        const modifiedData = {
            ...roomData,
            isLeader: isLeader(),
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        if (!isLeader()) {
            $(this.elms.removeSelected).hide();
        }
    }

    setTestMode() {
        if (isTestMode()) {
            $(this.elms.checkBtn).removeClass("disabled");
            $(".app__back").removeClass("hidden");
        }
    }

    setGameState() {
        const self = this;
        const elms = this.elms;
        const roomId = this.roomId;
        const thisRoomStatus = getRoomStatus(roomId);
        const roomAnswers = getFinalTeamAnswers(roomId);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        const setAnswers = (answers) => {
            const $theBoxes = $(elms.flowchartBox);
            const $thePopups = $(elms.popupItem);

            // reset flowchart boxes state
            $theBoxes.removeClass("is-item-selected");
            $theBoxes.attr("data-answer", "");
            $theBoxes.find(elms.selectedItemImage).attr("src", "");
            $theBoxes.find(elms.selectedItemTitle).text("");

            // reset popup items state
            $thePopups.attr("data-category-id", "");
            $thePopups
                .find(elms.selectionBox)
                .removeClass("is-selected")
                .prop("checked", false);
            $thePopups
                .find(elms.selectionBox)
                .not(".is-selected")
                .prop("disabled", false);

            // set current answers
            $.each(answers, function (index, answer) {
                const categoryId = String(index);
                const $thePopup = $(`${elms.popupItem}[data-id="${answer}"]`);
                const $theSelection = $thePopup.find(
                    `${elms.selectionBox}[data-id="${categoryId}"]`,
                );
                const popupTitle = $thePopup.find(elms.popupItemTitle).text();
                const popupIcon = $thePopup.attr("data-icon");
                const popupData = {
                    icon: popupIcon,
                    title: popupTitle,
                };

                $thePopup.attr("data-category-id", categoryId);

                $theSelection.addClass("is-selected").prop("checked", true);

                $thePopup
                    .find(elms.selectionBox)
                    .not(".is-selected")
                    .prop("disabled", true);

                self.setSelectedBox(categoryId, answer, popupData);
            });

            self.toggleCheckButton();
        };

        if (Object.values(roomAnswers).length > 0) {
            setAnswers(roomAnswers);
        } else {
            const tempAnswers = getTeamAnswers(roomId);
            setAnswers(tempAnswers);
        }

        /* force players to be on the same screen */
        const currentScreen = getCurrentRoomScreen(roomId);

        switch (currentScreen) {
            // case "search-find":
            //     $(".narrative-layer").show();
            //     $(".search-and-find-bg").show();
            //     break;
            case "video-intro":
                this.playIntroVideo();
                break;
            case "reward-screen":
                this.goToRewardScreen();
                break;
            case "customisations-screen":
                this.goToCustomizationScreen();
                break;
            case "puzzle-screen":
                $(".narrative-layer .screen .screen__inner").addClass("enter");
                setTimeout(() => {
                    $(".narrative-layer").css({
                        opacity: 0,
                        "pointer-events": "none",
                    });
                }, 500);
                this.handleBriefingPopup();
                $(".videobox").removeClass("is-open");
                $(elms.rewardScreen).removeClass("active");
                $(elms.customizationScreen).removeClass("active");
                break;
            default:
            //
        }
        /* END: force players to be on the same screen */

        const isRoomTimeout = getIsRoomTimeOut(roomId);
        if (isRoomTimeout && isLeader()) {
            $(this.elms.checkBtn).removeClass("disabled");
        }
    }

    handleBriefingPopup() {
        let roomId = this.roomId;

        // fix https://www.pivotaltracker.com/story/show/186872215
        if (!isNaN(parseInt(roomId.toString()))) {
            roomId = parseInt(roomId.toString());
        }

        let states = Storage.get("states", {});
        if (!states?.briefing) states.briefing = [];

        if (!states.briefing.includes(roomId)) {
            GameLogic.toggleBriefing();
        }
    }

    skipIntroVideo() {
        const videos = videojs.getPlayers();
        const introVideo = videos["intro-video-hotspot-puzzle"];
        
        introVideo.dispose();
        this.afterPlayIntroVideo();
    }

    afterPlayIntroVideo() {
        const $introVideo = $(".videobox");
        const is_leader = isLeader();

        let states = Storage.get("states", {});
        let introStates = states?.introVideo || [];

        $introVideo.removeClass("is-open");

        introStates.push(this.roomId);
        states.introVideo = introStates;
        Storage.set("states", states);

        if (is_leader)
            updateCurrentScreen(this.roomId, "puzzle-screen");

    }

    /* play intro video */
    playIntroVideo() {
        const $introVideo = $(".videobox");
        const $narrativePopup = $(".js-narrative-popup");
        const introVideoUrl = this._data.video_block.video_intro;
        const is_leader = isLeader();

        $narrativePopup.removeClass("is-open");

        if (!$introVideo.length) return false;

        let states = Storage.get("states", {});
        let introStates = states?.introVideo || [];

        /**
         * check wheiter the video has url or not
         * if no url, close video popup
         **/
        if (introVideoUrl === "false") {
            $introVideo.removeClass("is-open");
            return false;
        }

        if (!introStates.includes(this.roomId)) {
            // init video js with full screen
            const introVideo = videojs("intro-video-hotspot-puzzle", {
                controls: true,
                autoplay: true,
                preload: "auto",
                sources: [
                    {
                        src: introVideoUrl,
                        type: "video/mp4",
                    },
                ],
                techOrder: ["html5"],
            });

            // handle on ended video
            introVideo.on("ended", () => {
                introVideo.dispose();
                this.afterPlayIntroVideo();
            });

            // handle on error video
            introVideo.on("error", function () {
                console.error("Can't play the video");
            });

            $introVideo.addClass("is-open");
            if (is_leader) updateCurrentScreen(this.roomId, "video-intro");

            try {
                introVideo.play().catch((error) => {
                    // Autoplay was blocked. Do something
                    console.error("Unable to start auto play", error);

                    if (is_leader)
                        updateCurrentScreen(this.roomId, "puzzle-screen");
                });
            } catch (error) {
                console.error(error);

                if (is_leader)
                    updateCurrentScreen(this.roomId, "puzzle-screen");
            }
        } else {
            $introVideo.removeClass("is-open");
        }
    }

    toggleHideDashboard() {
        const $dashboardFlowchartElement = $(".hotspot-puzzle__dashboard");
        const isHidden = $dashboardFlowchartElement.hasClass("hide-dashboard");

        $dashboardFlowchartElement.toggleClass("hide-dashboard", !isHidden);
    }

    // handle open and close popup item
    togglePopupItem(e, el) {
        const elms = this.elms;
        const $popupItem = $(el).parents(elms.popupItem);
        const isOpen = $popupItem.hasClass("is-open");
        const $otherPopups = $(elms.popupItem);

        $otherPopups.removeClass("is-open");
        $otherPopups.toggleClass("disable-popup", !isOpen);
        $popupItem.toggleClass("is-open", !isOpen);
        if (isOpen) {
            $(".hotspot-puzzle__dashboard").css("z-index", 3);
        } else {
            $(".hotspot-puzzle__dashboard").css("z-index", 1);
        }
    }

    onSelectBox(e, el) {
        const is_leader = isLeader();
        if (!is_leader) {
            $(el).prop("checked", !$(el).prop("checked"));
            return;
        }

        const roomId = this.roomId;
        const roomStatus = getRoomStatus(roomId);
        if (roomStatus === "is-status-completed") return;

        const $this = $(el);
        const elms = this.elms;
        const boxId = $this.attr("data-id");
        const $popupItem = $this.parents(elms.popupItem);
        const popupId = $popupItem.attr("data-id");
        const popupIcon = $popupItem.attr("data-icon");
        const popupTitle = $popupItem.find(elms.popupItemTitle).text();
        const isSelected = $this.hasClass("is-selected");
        const type = isSelected ? "unselect" : "select";
        const isConfidentalItem =
            $popupItem.attr("data-confidental") === "true";
        const $selectionParent = $this.parents(elms.selectionBoxWrapper);
        const $selectionBoxes = $selectionParent.find(elms.selectionBox);

        const popupData = {
            icon: popupIcon,
            title: popupTitle,
        };

        if (isConfidentalItem) {
            // handle confidental item
            $selectionParent.addClass("is-confidental-item");
            $popupItem.addClass("is-not-selectable");
        } else {
            // handle selection boxes
            $(`${elms.selectionBox}[data-id="${boxId}"]`)
                .removeClass("is-selected")
                .prop("checked", false);

            $selectionBoxes.removeClass("is-selected");
            $selectionBoxes.not($this).prop("disabled", !isSelected);
            $this.toggleClass("is-selected", !isSelected);

            // handle popup item
            $popupItem
                .toggleClass("is-selected", !isSelected)
                .attr("data-category-id", boxId);

            this.setSelectedBox(boxId, popupId, popupData, type);
            this.setTeamAnswers(boxId, popupId, type);
        }

        this.toggleCheckButton();
    }

    // handle selected box
    setSelectedBox(id, popupId, popupData, type) {
        const elms = this.elms;
        const $theBox = $(`${elms.flowchartBox}[data-id="${id}"]`);
        const isUnselectBox = type === "unselect";

        if (isUnselectBox) {
            $theBox.removeClass("is-item-selected");
            $theBox.attr("data-answer", "");
            $theBox.find(elms.selectedItemImage).attr("src", "");
            $theBox.find(elms.selectedItemTitle).text("");
        } else {
            $theBox.addClass("is-item-selected");
            $theBox.attr("data-answer", popupId);
            $theBox.find(elms.selectedItemImage).attr("src", popupData?.icon);
            $theBox.find(elms.selectedItemTitle).text(popupData?.title);
        }
    }

    setTeamAnswers(categoryId, answer, type) {
        const roomId = this.roomId;
        const updatedStatusRoom = "is-status-started";

        getRoomAnswers(roomId).then((data) => {
            const userAnswer = data.val() ?? {};

            if (type === "unselect") {
                removeRoomAnswer(roomId, categoryId);
            } else {
                const answerData = {
                    ...userAnswer,
                    [categoryId]: answer,
                };

                updateRoomAnswer(roomId, answerData);
            }
        });

        maybeUpdateRoomStatus(roomId, updatedStatusRoom);
    }

    toggleCheckButton() {
        const elms = this.elms;
        const $checkBtn = $(elms.checkBtn);
        const $theBoxes = $(elms.flowchartBox).not(".static-chart");
        let isAllAnswered = true;

        $.each($theBoxes, function (index, item) {
            const $this = $(item);
            const answer = $this.attr("data-answer");
            const hasAnswer = answer !== "";

            if (!hasAnswer) return (isAllAnswered = false);
        });

        $checkBtn.toggleClass("disabled", !isAllAnswered);
        this.setTestMode();
    }

    onRemoveBox(e, el) {
        const is_leader = isLeader();
        if (!is_leader) {
            return;
        }

        const roomId = this.roomId;
        const roomStatus = getRoomStatus(roomId);
        if (roomStatus === "is-status-completed") return;

        const elms = this.elms;
        const $this = el;
        const $theBox = $this.parent();
        const categoryId = $theBox.attr("data-id");
        const $thePopup = $(`
            ${elms.popupItem}[data-category-id="${categoryId}"]
        `);
        const popupId = $thePopup.attr("data-id");

        $theBox.removeClass("is-item-selected").attr("data-answer", "");

        $thePopup.attr("data-category-id", "");
        $thePopup
            .find(`${elms.selectionBox}.is-selected`)
            .removeClass("is-selected")
            .prop("checked", false);
        $thePopup.find(elms.selectionBox).removeAttr("disabled");

        this.setTeamAnswers(categoryId, popupId, "unselect");

        $this.addClass("hidden");
    }

    handleRemoveButtonVisibility(e, el) {
        const $el = $(el);
        const roomId = this.roomId;
        const roomStatus = getRoomStatus(roomId);
        const hasAnswer = $el.attr("data-answer") !== "";
        const isHidden = roomStatus === "is-status-completed" || !hasAnswer;
        const $removeButton = $(this.elms.removeSelected);

        $removeButton.toggleClass("hidden", isHidden);
    }

    calculateScore(totalCorrect) {
        const rewards = this._data.points_earned || [];
        const score = 10;

        // @ts-ignore
        const reward = rewards.find(
            (item) => totalCorrect == item.total_correct_boxes,
        );

        return Number(reward?.points) || score;
    }

    // handle on check answers
    checkAnswer(e, el) {
        // const is_leader = this.isTeamLeader;
        const is_leader = isLeader();
        if (!is_leader) {
            this.goToRewardScreen();
            return;
        }

        const $this = $(el);
        const elms = this.elms;
        const roomId = this.roomId;
        const currentRoomStatus = getRoomStatus(roomId);
        const completedStatus = "is-status-completed";
        const $thePopups = $(elms.popupItem);
        // const $continueBtn = $(elms.continueBtn);

        $thePopups.removeClass("is-open");

        if (currentRoomStatus === completedStatus) {
            this.goToRewardScreen();
            return;
        }

        let totalAttempts = getTotalAttempt(roomId);
        const roomAnswers = getRoomAnswerById(roomId);
        const $theBoxes = $(elms.flowchartBox).not(".static-chart");
        let playerAnswers = {};
        let correct = 0;
        // let wrong = 0;

        $.each($theBoxes, function (index, item) {
            const $this = $(item);
            const categoryId = $this.attr("data-id");
            const answer = $this.attr("data-answer");

            playerAnswers[categoryId] = answer;
        });

        $.each(roomAnswers, function (index, item) {
            const categoryId = index;
            const correctAnswers = item;
            const teamAnswer = playerAnswers[categoryId];
            const isCorrect = correctAnswers.includes(teamAnswer);

            if (isCorrect) correct++;
        });

        totalAttempts++;
        setTotalAttempt(roomId, totalAttempts);

        let updatedStatusRoom = "is-status-started";
        // const isAllCorrect = wrong == 0 && correct > 0;

        // if(isAllCorrect) {
        updatedStatusRoom = completedStatus;
        const roomScore = this.calculateScore(correct);

        const onSuccess = () => {
            setRoomTotalScores(roomId, roomScore);

            $(".app__page").addClass("is-room-completed");
            $this.addClass("disabled");
            // $continueBtn.removeClass("disabled hidden");
        };

        saveFinalRoomAnswers(roomId, playerAnswers).then(onSuccess).catch();

        maybeUpdateRoomStatus(roomId, updatedStatusRoom)
            .then(() => {
                /**
                 * check if completion popup text is empty
                 * if empty, go to reward screen directly
                 * if has content, the content is appeared (see GameLogic)
                 */
                const roomData = this._data;
                const { completion_popup } = roomData;
                const { title, content } = completion_popup;

                if (!title && !content) this.goToRewardScreen();
            })
            .catch();
    }

    /* show feedback reward screen */
    goToRewardScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const rewards = this._data.rewards || [];
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const teamname = CONFIG.game.teamname;
        const is_leader = isLeader();
        const $completionPopUp = $(".js-room-completion");

        // @ts-ignore
        const reward = rewards.find((item) => roomScore == Number(item.points));

        let title, subtitle, description;

        if (reward?.title) {
            title = reward.title;
            title = title.replaceAll("{team_name}", teamname);
        }

        if (reward?.subtitle) subtitle = reward.subtitle;

        if (reward?.description) description = reward.description;

        $completionPopUp.removeClass("is-open");

        $rewardPopup.addClass("active");
        $rewardPopup.find(elms.rewardTitle).text(title);
        $rewardPopup.find(elms.rewardSubtitle).text(subtitle);
        $rewardPopup.find(elms.rewardDescription).html(description);
        $rewardPopup.find(elms.rewardScore).text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "reward-screen");

        // hide timer hint popup
        $(".js-popup-timerhint").removeClass("is-open");
    }

    /* show customization screen */
    goToCustomizationScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const is_leader = isLeader();
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const $customizationPopup = $(elms.customizationScreen);
        const $score = $(elms.rewardScore);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);

        $(elms.customizationCategory).each(function () {
            const $slider = $(this).find(".challange-prize__item-wrapper");
            const isInitialized = $slider.hasClass("slick-initialized");
            const sliderCustomRewardOption = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
                prevArrow: $(this).find(`.challange-prize__item-prev`),
                nextArrow: $(this).find(`.challange-prize__item-next`),
            };

            if (!isInitialized) $slider.slick(sliderCustomRewardOption);
        });

        $selectedCategory.addClass("is-selected");
        $rewardPopup.removeClass("active");
        $customizationPopup.addClass("active");
        $score.text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "customisations-screen");
    }

    setSelectedLogo() {
        const elms = this.elms;
        const roomId = this.roomId;
        const is_leader = isLeader();
        const roomLogo = getRoomLogo(roomId);
        const roomScore = getRoomScore(roomId);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);
        const $activeSlide = $selectedCategory.find(".slick-active");
        const $theImg = $activeSlide.find(elms.logoImage);
        const selectedImg = $theImg.attr("data-image");

        // redirect player to mainroom
        const goToMainroom = () => {
            const mainRoomID = CONFIG?.game?.rooms.find(
                (key) => key.id == roomId,
            ).mainroom_id;

            if (is_leader) updateCurrentScreen(roomId, null);
            GameLogic.goToPage(mainRoomID);
        };

        if (roomLogo) goToMainroom();

        if (selectedImg == undefined) {
            goToMainroom();
            return false;
        }

        if (is_leader) {
            setTeamLogos(roomId, selectedImg)
                .then(goToMainroom)
                .catch(goToMainroom);
        } else {
            goToMainroom();
        }
    }

    setupSlider() {
        const sliderSourcePopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".source-popup__nav-item.nav-pagination"),
            prevArrow: $(".source-popup__nav-item.nav-left"),
            nextArrow: $(".source-popup__nav-item.nav-right"),
        };

        const sliderInfoPopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".msn-popup__nav-item.nav-pagination"),
            prevArrow: $(".msn-popup__nav-item.nav-left"),
            nextArrow: $(".msn-popup__nav-item.nav-right"),
        };

        $(".js-source-wrapper").slick(sliderSourcePopup);
        $(".js-info-slider-wrapper").slick(sliderInfoPopup);
        $(".js-source-wrapper").slick("refresh");
        $(".js-info-slider-wrapper").slick("refresh");
    }

    closeNarrativePopup() {
        GameLogic.toggleNarrative();

        this.playIntroVideo();
    }
}
